/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Route,
  Redirect, useHistory, useLocation,
} from 'react-router-dom';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import LayoutNew from '../LayoutNew';
import Layout from '../Layout';

function ProtectedRoute({ children, isAuthenticated, ...rest }) {

  const { isLoggedIn } = useSelector(state => state.user);
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();
  const hideSidebar = location.pathname === '/';
  // console.log('das', isLoggedIn);
  const history = useHistory();
  // console.log('isLoggedInisLoggedInisLoggedInisLoggedInisLoggedInisLoggedInisLoggedInisLoggedIn', isLoggedIn);
  return (
    <>
      <div>
        {isLoggedIn ? <Layout /> : <LayoutNew />}
        <ContainerWrap hideSidebar={hideSidebar}>
          <Route
            {...rest}
            render={
        ({ location }) => (
          
              children
            
            )
      }
          />
        </ContainerWrap>
      </div>

    </>

   
  );
}

export default ProtectedRoute;
const ContainerWrap = styled.div`
  position: relative;
  z-index: 0;
  padding-top: ${props => (props.hideSidebar ? '0' : '')};
  min-height: 100vh;
  background: transparent;

  @media screen and (min-width: 576px) {
    ${props => props.hideSidebar && `
      display: flex;
      justify-content: center;
      align-items: flex-start;
    `}
  }

  @media screen and (max-width: 576px) {
    padding-top: ${props => (props.hideSidebar ? '0' : '112px')};
  }
  
  ${props => props.hideSidebar && `
    > * {
      width: 100%;
      max-width: 100%;
    }
  `}
`;